export default __webpack_public_path__ + "static/media/television.fa38ffac.png";